import { useMutation } from '@tanstack/react-query';
import { requestEmailUpdate, verifyEmailUpdate } from '../../api/apiOtp';

/**
 * Hook for updating email address (authenticated users)
 * Two-step process: request OTP → verify OTP
 * @returns {Object} Mutations for both steps
 */
export const useEmailUpdate = () => {
    // Step 1: Request OTP for new email
    const requestMutation = useMutation({
        mutationFn: ({ email }) => {
            return requestEmailUpdate(email);
        }
    });

    // Step 2: Verify OTP and update email
    const verifyMutation = useMutation({
        mutationFn: ({ email, otp }) => {
            return verifyEmailUpdate(email, otp);
        }
    });

    return {
        // Request OTP
        requestUpdate: requestMutation.mutate,
        requestUpdateAsync: requestMutation.mutateAsync,
        isRequesting: requestMutation.isPending,
        requestError: requestMutation.error,
        requestData: requestMutation.data,

        // Verify OTP
        verifyUpdate: verifyMutation.mutate,
        verifyUpdateAsync: verifyMutation.mutateAsync,
        isVerifying: verifyMutation.isPending,
        verifyError: verifyMutation.error,
        verifyData: verifyMutation.data,

        // Combined state
        isPending: requestMutation.isPending || verifyMutation.isPending
    };
};
